import CourseCard from "./CourseCard";
import { useLocation, Link } from "react-router-dom";
import coursesData from "../../data/CourseData"; // Archivo con los datos de los cursos
import imgHeader from "../../assets/img/page-header.webp";

const Courses = () => {
    // const courses = coursesData;
    const location = useLocation();
    const shouldShowDiv = !["/"].includes(location.pathname);

    return (
        <div>
            {shouldShowDiv && (
                <div className="w-100 overflow-hidden mb-5 position-relative" style={{ minHeight: '300px' }}>
                    <img
                        src={imgHeader}
                        alt="Encabezado de página curso online"
                        className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                        style={{ zIndex: 0 }}
                        loading="eager"
                        decoding="async"
                    />

                    <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}></div>

                    <div className="container position-relative" style={{ zIndex: 2 }}>
                        <div className="d-flex flex-column justify-content-center h-100" style={{ minHeight: '300px' }}>
                            <h3 className="display-4 text-white text-uppercase">Formaciones</h3>
                            <div className="d-inline-flex text-white">
                                <p className="m-0 text-uppercase">
                                    <Link to="/">Inicio</Link>
                                </p>
                                <i className="fa fa-angle-double-right pt-1 px-3"></i>
                                <p className="m-0 text-uppercase">Cursos</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="container-fluid py-5">
                <div className="container py-5">
                    <div className="text-center mb-5">
                        <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>Cursos y Talleres</h5>
                        <h1>Nuestras formaciones más compradas</h1>
                    </div>
                    <div className="row">
                        {coursesData.map((course, index) => (
                            <CourseCard key={index} {...course} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Courses;